import a from './img/a.jpg'
import a_movable from './img/a_movable.jpg'
import vagabonding from './img/vagabonding.jpg'
import a_year from './img/a_year.jpg'
import arabian_sands from './img/arabian_sands.jpg'
import around_the from './img/around_the.jpg'
import blue_highways from './img/blue_highways.jpg'
import dark_star_safari from './img/dark_star_safari.jpg'
import down_and from './img/down_and.jpg'
import eat_pray_love from './img/eat_pray_love.jpg'
import great_plains from './img/great_plains.jpg'
import in_patagonia from './img/in_patagonia.jpg'
import into_the_wild from './img/into_the_wild.jpg'
import into_thin_air from './img/into_thin_air.jpg'
import love from './img/love.jpg'
import maximum from './img/maximum.jpg'
import on_the_road from './img/on_the_road.jpg'
import places from './img/places.jpg'
import stranger from './img/stranger.jpg'
import the_Art_of_travel from './img/the_Art_of_travel.jpg'
import the_great_railway from './img/the_great_railway.jpg'
import the_rings  from './img/the_rings.jpg'
import the_road_to from './img/the_road_to.jpg'
import unlikely from './img/unlikely.jpg'



export const TBookItems = [
  {
    id:501,
    title:"Eric Newby",
    image: a,
    price:999,
    
  },
  {
    id:502,
    title:"A Moveable Feast",
    image: a_movable,
    price:299,
    
  },
  {
    id:503,
    title:"Vagabonding",
    image: vagabonding,
    price:599,
    
  },
  {
    id:504,
    title:"A Year in Provence",
    image: a_year,
    price:999,
    
  },
  {
    id:505,
    title:"Arabian Sands",
    image: arabian_sands,
    price:439,
    
  },
  {
    id:506,
    title:"Around the World in 80 Days",
    image: around_the,
    price:99,
    
  },
  {
    id:507,
    title:"Blue Highways",
    image: blue_highways,
    price:1459,
    
  },
  {
    id:508,
    title:"Dark Star Safari",
    image: dark_star_safari,
    price:399,
    
  },
  {
    id:509,
    title:"Down and Out in Paris and London",
    image: down_and,
    price:999,
    
  },
  {
    id:510,
    title:"Eat Pray Love",
    image: eat_pray_love,
    price:1499,
    
  },
  {
    id:511,
    title:"Great Plains",
    image: great_plains,
    price:1419,
    
  },
  {
    id:512,
    title:"In Patagonia",
    image: in_patagonia,
    price:1239,
    
  },
  {
    id:513,
    price:799,
    title: "Into the Wild",
    image: into_the_wild,
    
  },
  {
    id:514,
    price:1349,
    title: "Into thin Air",
    image: into_thin_air,
   
  },
  {id:515,
    price:1999,
    title: "Love with a Chance of Drowning",
    image: love,
    
  },
  {
    id:516,
    price:1599,
    title: "Maximum City",
    image: maximum,
    
  },
  {
    id:517,
    price:5779,
    title: "On the Road",
    image: on_the_road,
    
  },
  {
    id:518,
    price:1729,
    title: "1000 Places to See Before You Die",
    image: places,
    
  },
  {
    id:519,
    price:499,
    title: "Stranger on a Train",
    image: stranger,
    
  },
  {
    id:520,
    price:1899,
    title: "The Art of Travel",
    image: the_Art_of_travel,
    
  },
  {
    id:521,
    price:1999,
    title: "The Great Railway Bazaar",
    image: the_great_railway,
    
  },
  {
    id:522,
    price:1999,
    title: "The Rings of Saturn",
    image:the_rings,    
  },
  {
    id:523,
    price:1999,
    title: "The Road to Oxiana",
    image: the_road_to,
    
  },
  {
    id:524,
    price:2339,
    title: "Unlikely Destinations",
    image: unlikely,
    
  },
  
];